import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.dashboard');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-dashboard',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.dashboard/view.scss */
.arcade-start {
  --pixel-font: "Lucida Console", "Courier New", monospace;
  --pixel-ink: #fff8cf;
  --pixel-black: #050505;
  position: relative;
  min-height: 100vh;
  padding: 18px;
  overflow-x: hidden;
  overflow-y: auto;
  background: repeating-linear-gradient(90deg, rgba(248, 236, 24, 0.05) 0 8px, transparent 8px 24px), repeating-linear-gradient(180deg, rgba(18, 231, 255, 0.04) 0 6px, transparent 6px 22px), linear-gradient(180deg, #151515 0%, #070707 48%, #000 100%);
  color: #fff;
  font-family: var(--pixel-font);
  image-rendering: pixelated;
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.arcade-start,
.arcade-start * {
  box-sizing: border-box;
}

.arcade-start :is(.score-label,
.score-slot strong,
.system-strip span,
.arcade-kicker,
.bubble-logo,
.arcade-subtitle,
.status-deck span,
.entry-heading,
.player-input,
.mode-button,
.coin-button,
.start-button,
.opponent-button,
.match-heading,
.match-result,
.match-copy,
.ready-message,
.arcade-footer span) {
  font-family: var(--pixel-font);
  font-variant-ligatures: none;
  -webkit-font-smoothing: none;
  text-rendering: geometricPrecision;
  text-transform: uppercase;
  letter-spacing: 0;
}

.arcade-start :is(.arcade-kicker,
.arcade-subtitle,
.entry-heading,
.status-deck span,
.match-heading,
.match-result,
.match-copy,
.ready-message,
.arcade-footer span) {
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000;
}

.arcade-start::before {
  content: "";
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(53, 255, 97, 0.06) 1px, transparent 1px), linear-gradient(90deg, rgba(18, 231, 255, 0.04) 1px, transparent 1px);
  background-size: 16px 16px;
  opacity: 0.5;
  pointer-events: none;
}

.arcade-start::after {
  content: "";
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at center, transparent 0 48%, rgba(0, 0, 0, 0.46) 78%, rgba(0, 0, 0, 0.86) 100%), linear-gradient(90deg, rgba(255, 0, 0, 0.05), rgba(0, 255, 80, 0.035), rgba(0, 170, 255, 0.05));
  opacity: 0.55;
  pointer-events: none;
}

.arcade-scanline {
  position: absolute;
  inset: 0;
  z-index: 6;
  background: repeating-linear-gradient(180deg, rgba(255, 255, 255, 0.06) 0, rgba(255, 255, 255, 0.06) 1px, transparent 1px, transparent 4px);
  mix-blend-mode: screen;
  opacity: 0.24;
  pointer-events: none;
}

.screen-noise {
  position: absolute;
  inset: 0;
  z-index: 5;
  background-image: radial-gradient(circle, rgba(255, 255, 255, 0.16) 0 1px, transparent 1px), radial-gradient(circle, rgba(0, 255, 80, 0.08) 0 1px, transparent 1px);
  background-position: 0 0, 6px 4px;
  background-size: 10px 10px, 14px 14px;
  mix-blend-mode: screen;
  opacity: 0.12;
  pointer-events: none;
  animation: noise-shift 1.1s steps(2, end) infinite;
}

.crt-shell {
  position: relative;
  z-index: 1;
  width: min(100%, 1180px);
  min-height: calc(100vh - 36px);
  padding: 22px 20px 26px;
  border: 10px solid #242424;
  outline: 4px solid #050505;
  background: linear-gradient(135deg, #343434 0 12px, #151515 12px 26px, #303030 26px 38px, #101010 38px), #161616;
  box-shadow: 0 0 0 5px #5a5a5a, 14px 18px 0 #000, inset 0 0 0 5px #070707, inset 0 0 40px rgba(0, 0, 0, 0.75);
}

.crt-shell::before,
.crt-shell::after {
  content: "";
  position: absolute;
  top: 16px;
  bottom: 16px;
  width: 12px;
  background: repeating-linear-gradient(180deg, #080808 0 5px, #2d2d2d 5px 9px);
  box-shadow: inset 0 0 0 2px #000;
}

.crt-shell::before {
  left: 12px;
}

.crt-shell::after {
  right: 12px;
}

.cabinet-speakers {
  position: absolute;
  left: 50%;
  bottom: 8px;
  transform: translateX(-50%);
  display: grid;
  grid-template-columns: repeat(4, 42px);
  gap: 12px;
}

.cabinet-speakers span {
  height: 6px;
  background: #080808;
  box-shadow: 0 2px 0 #3b3b3b;
}

.arcade-stage {
  position: relative;
  z-index: 1;
  width: min(100%, 1100px);
  min-height: calc(100vh - 106px);
  margin: 0 auto;
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: radial-gradient(ellipse at center, rgba(22, 255, 92, 0.08) 0 12%, transparent 42%), linear-gradient(180deg, rgba(10, 16, 14, 0.9), rgba(0, 0, 0, 0.98));
  border: 6px solid #050505;
  box-shadow: inset 0 0 0 4px #535353, inset 0 0 0 9px #111, inset 0 0 75px rgba(53, 255, 97, 0.16);
  animation: crt-flicker 5.8s steps(1, end) infinite;
}

.arcade-stage::before {
  content: "";
  position: absolute;
  inset: 0;
  background: repeating-linear-gradient(90deg, rgba(255, 0, 0, 0.035) 0 1px, transparent 1px 3px), repeating-linear-gradient(180deg, transparent 0 7px, rgba(53, 255, 97, 0.055) 7px 8px);
  opacity: 0.65;
  pointer-events: none;
}

.scoreboard,
.system-strip,
.title-screen {
  position: relative;
  z-index: 1;
}

.scoreboard {
  display: grid;
  grid-template-columns: 1fr 1.4fr 1fr;
  gap: 12px;
  align-items: start;
  text-align: center;
  text-shadow: 3px 3px 0 #000, 0 0 12px currentColor;
}

.score-slot {
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;
}

.score-slot strong {
  margin-top: 4px;
  color: #fff;
  font-size: 30px;
  font-weight: 900;
  text-shadow: 3px 0 0 #000, 0 3px 0 #000, 3px 3px 0 #000, 0 0 8px #fff;
}

.score-label {
  font-size: 30px;
  font-weight: 900;
  text-shadow: 3px 0 0 #000, 0 3px 0 #000, 3px 3px 0 #000;
}

.score-label-1p {
  color: #00ff42;
}

.score-label-high {
  color: #ff2b1f;
}

.score-label-2p {
  color: #12e7ff;
}

.system-strip {
  width: min(100%, 760px);
  margin: 12px auto 0;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border: 3px solid #242424;
  background: #030303;
  box-shadow: 4px 4px 0 #000, inset 0 0 0 2px #111;
}

.system-strip span {
  min-width: 0;
  padding: 7px 8px 6px;
  color: #35ff61;
  border-right: 2px solid #242424;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
  text-align: center;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 8px rgba(53, 255, 97, 0.72);
  white-space: nowrap;
}

.system-strip span:nth-child(2) {
  color: #12e7ff;
}

.system-strip span:nth-child(3) {
  color: #f8ec18;
}

.system-strip span:last-child {
  color: #ff5aa6;
  border-right: 0;
}

.title-screen {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 18px;
  padding: 14px 0 0;
}

.bubble-cloud {
  position: absolute;
  inset: 60px 2% 36px;
  pointer-events: none;
}

.float-bubble {
  position: absolute;
  display: block;
  border: 4px solid #c68400;
  background: #f8ec18;
  clip-path: polygon(25% 0, 75% 0, 75% 10%, 90% 10%, 90% 25%, 100% 25%, 100% 75%, 90% 75%, 90% 90%, 75% 90%, 75% 100%, 25% 100%, 25% 90%, 10% 90%, 10% 75%, 0 75%, 0 25%, 10% 25%, 10% 10%, 25% 10%);
  box-shadow: 5px 5px 0 #111, 0 0 12px rgba(248, 236, 24, 0.42), inset -8px -8px 0 #e48a00;
  opacity: 0.9;
  animation: bubble-drift 3.4s steps(4, end) infinite;
}

.float-bubble::before,
.float-bubble::after {
  content: "";
  position: absolute;
  display: block;
  background: #fff9b7;
}

.float-bubble::before {
  left: 22%;
  top: 18%;
  width: 18%;
  height: 18%;
}

.float-bubble::after {
  right: 20%;
  bottom: 20%;
  width: 12%;
  height: 12%;
  background: #ffba1f;
}

.logo-zone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.logo-zone::before,
.logo-zone::after {
  content: "";
  position: absolute;
  top: 50%;
  width: 84px;
  height: 12px;
  background: repeating-linear-gradient(90deg, #ff2525 0 10px, #f8ec18 10px 20px, #12e7ff 20px 30px);
  box-shadow: 4px 4px 0 #000;
}

.logo-zone::before {
  right: calc(100% + 22px);
}

.logo-zone::after {
  left: calc(100% + 22px);
}

.arcade-kicker {
  margin: 0 0 8px;
  padding: 2px 8px;
  color: #ff3b2f;
  font-size: 22px;
  font-weight: 900;
  background: #070707;
  border: 3px solid #101010;
  box-shadow: 4px 4px 0 #000, inset 0 -4px 0 rgba(255, 37, 37, 0.28);
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #12e7ff;
}

.bubble-logo {
  position: relative;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #24f7ff;
  font-size: 68px;
  line-height: 0.94;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
  -webkit-text-stroke: 0;
  transform: scaleY(0.92);
  text-shadow: 3px 0 0 #0047a8, -3px 0 0 #0047a8, 0 3px 0 #0047a8, 0 -3px 0 #0047a8, 3px 3px 0 #0047a8, 7px 7px 0 #ff2fb3, 10px 10px 0 #5b1fd7, -2px 0 0 #fff8cf, 2px 0 0 #ff2525;
}

.bubble-logo span {
  display: block;
  padding: 0 14px 3px;
  background: linear-gradient(180deg, #fff8cf 0 18%, #24f7ff 18% 55%, #168cff 55% 100%);
  color: #24f7ff;
}

@supports (-webkit-background-clip: text) {
  .bubble-logo span {
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
  }
}
.bubble-logo::before {
  content: "";
  position: absolute;
  inset: -24px -58px -24px;
  z-index: -1;
  background: repeating-linear-gradient(0deg, rgba(255, 178, 29, 0.24) 0 8px, transparent 8px 16px), repeating-linear-gradient(90deg, rgba(5, 5, 5, 0.13) 0 8px, transparent 8px 24px), #fff400;
  clip-path: polygon(8% 0, 92% 0, 92% 8%, 100% 8%, 100% 26%, 94% 26%, 94% 74%, 100% 74%, 100% 92%, 92% 92%, 92% 100%, 8% 100%, 8% 92%, 0 92%, 0 74%, 6% 74%, 6% 26%, 0 26%, 0 8%, 8% 8%);
  box-shadow: 8px 8px 0 #171717, inset 0 0 0 8px #101010, inset 0 0 0 14px #f8ec18, inset -14px -14px 0 rgba(255, 128, 0, 0.42);
}

.bubble-logo::after {
  content: "";
  position: absolute;
  inset: -12px -42px -10px;
  z-index: -1;
  border: 4px solid #101010;
  clip-path: polygon(5% 0, 95% 0, 95% 10%, 100% 10%, 100% 90%, 95% 90%, 95% 100%, 5% 100%, 5% 90%, 0 90%, 0 10%, 5% 10%);
  pointer-events: none;
}

.arcade-subtitle {
  margin: 20px 0 0;
  padding: 4px 10px;
  color: #fff8cf;
  font-size: 20px;
  font-weight: 900;
  background: #050505;
  border: 3px solid #1b1b1b;
  box-shadow: 4px 4px 0 #000, inset 0 -4px 0 rgba(18, 231, 255, 0.22);
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000;
}

.player-row {
  width: min(100%, 460px);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 34px;
  min-height: 96px;
}

.pixel-mascot {
  --body: #39e75f;
  --body-dark: #0d8f36;
  --body-light: #82ff95;
  --snout: #fff3cf;
  --foot: #f8ec18;
  --outline: #101010;
  position: relative;
  width: 82px;
  height: 74px;
  border: 0;
  background: transparent;
  filter: drop-shadow(6px 6px 0 #000) drop-shadow(0 0 12px rgba(255, 255, 255, 0.16));
  image-rendering: pixelated;
}

.pixel-mascot::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: 0;
  background: var(--body);
  clip-path: polygon(14px 0, 56px 0, 56px 6px, 70px 6px, 70px 16px, 82px 16px, 82px 56px, 76px 56px, 76px 68px, 58px 68px, 58px 74px, 16px 74px, 16px 68px, 0 68px, 0 18px, 6px 18px, 6px 6px, 14px 6px);
  filter: drop-shadow(4px 0 0 var(--outline)) drop-shadow(-4px 0 0 var(--outline)) drop-shadow(0 4px 0 var(--outline)) drop-shadow(0 -4px 0 var(--outline));
  box-shadow: inset 8px 8px 0 var(--body-light), inset -10px -10px 0 var(--body-dark);
}

.pixel-mascot-green {
  --body: #39e75f;
  --body-dark: #0d8f36;
  --body-light: #82ff95;
}

.pixel-mascot-pink {
  --body: #ff5aa6;
  --body-dark: #b9286a;
  --body-light: #ff9ac8;
}

.pixel-mascot .horn,
.pixel-mascot .tail,
.pixel-mascot .arm,
.pixel-mascot .eye,
.pixel-mascot .snout,
.pixel-mascot .nostril,
.pixel-mascot .mouth,
.pixel-mascot .cheek,
.pixel-mascot .belly,
.pixel-mascot .foot {
  position: absolute;
  display: block;
  z-index: 1;
}

.pixel-mascot .horn {
  top: -10px;
  width: 14px;
  height: 14px;
  border: 4px solid var(--outline);
  background: var(--snout);
  clip-path: polygon(0 100%, 0 42%, 28% 42%, 28% 0, 72% 0, 72% 42%, 100% 42%, 100% 100%);
}

.pixel-mascot .horn-left {
  left: 18px;
}

.pixel-mascot .horn-right {
  right: 18px;
}

.pixel-mascot .tail {
  right: -24px;
  bottom: 13px;
  width: 30px;
  height: 22px;
  border: 4px solid var(--outline);
  background: var(--body);
  clip-path: polygon(0 22%, 64% 22%, 64% 0, 100% 0, 100% 70%, 74% 70%, 74% 100%, 0 100%);
  box-shadow: inset -6px -6px 0 var(--body-dark);
}

.pixel-mascot .arm {
  top: 42px;
  width: 17px;
  height: 24px;
  border: 4px solid var(--outline);
  background: var(--body);
  box-shadow: inset -4px -4px 0 var(--body-dark);
}

.pixel-mascot .arm-left {
  left: -13px;
  clip-path: polygon(0 0, 100% 0, 100% 70%, 72% 70%, 72% 100%, 0 100%);
}

.pixel-mascot .arm-right {
  right: -13px;
  clip-path: polygon(0 0, 100% 0, 100% 100%, 28% 100%, 28% 70%, 0 70%);
}

.pixel-mascot .eye {
  top: 14px;
  width: 14px;
  height: 18px;
  background: #fff;
  border: 4px solid var(--outline);
}

.pixel-mascot .eye::after {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  width: 4px;
  height: 8px;
  background: var(--outline);
}

.pixel-mascot .eye-left {
  left: 15px;
}

.pixel-mascot .eye-right {
  left: 36px;
}

.pixel-mascot .snout {
  left: 42px;
  top: 34px;
  width: 38px;
  height: 27px;
  border: 4px solid var(--outline);
  background: var(--snout);
  clip-path: polygon(0 0, 100% 0, 100% 70%, 82% 70%, 82% 100%, 0 100%);
  box-shadow: inset -5px -5px 0 #ffd77a;
}

.pixel-mascot .nostril {
  left: 58px;
  top: 42px;
  width: 5px;
  height: 5px;
  background: var(--outline);
  box-shadow: 12px 0 0 var(--outline);
  z-index: 2;
}

.pixel-mascot .mouth {
  left: 52px;
  top: 56px;
  width: 22px;
  height: 5px;
  background: var(--outline);
  box-shadow: 8px 5px 0 var(--outline);
  z-index: 2;
}

.pixel-mascot .cheek {
  left: 9px;
  top: 42px;
  width: 8px;
  height: 8px;
  background: rgba(255, 255, 255, 0.38);
  box-shadow: 58px 0 0 rgba(255, 255, 255, 0.28);
  z-index: 2;
}

.pixel-mascot .belly {
  left: 20px;
  bottom: 9px;
  width: 31px;
  height: 28px;
  border: 4px solid var(--outline);
  background: var(--snout);
  clip-path: polygon(12% 0, 88% 0, 88% 14%, 100% 14%, 100% 86%, 88% 86%, 88% 100%, 12% 100%, 12% 86%, 0 86%, 0 14%, 12% 14%);
  box-shadow: inset -5px -5px 0 #ffd77a;
}

.pixel-mascot .foot {
  bottom: -13px;
  width: 23px;
  height: 15px;
  border: 4px solid var(--outline);
  background: var(--foot);
  clip-path: polygon(0 0, 100% 0, 100% 72%, 72% 72%, 72% 100%, 0 100%);
}

.pixel-mascot .foot-left {
  left: 10px;
}

.pixel-mascot .foot-right {
  right: 8px;
}

.mini-bubbles {
  display: flex;
  gap: 9px;
  align-items: center;
}

.mini-bubbles span {
  width: 20px;
  height: 20px;
  border: 3px solid #e5f8ff;
  background: #18d7ef;
  clip-path: polygon(25% 0, 75% 0, 75% 14%, 86% 14%, 86% 25%, 100% 25%, 100% 75%, 86% 75%, 86% 86%, 75% 86%, 75% 100%, 25% 100%, 25% 86%, 14% 86%, 14% 75%, 0 75%, 0 25%, 14% 25%, 14% 14%, 25% 14%);
  box-shadow: 3px 3px 0 #000, inset -4px -4px 0 #087a99;
}

.mini-bubbles span:nth-child(2) {
  width: 28px;
  height: 28px;
  background: #f8ec18;
  box-shadow: 3px 3px 0 #000, inset -5px -5px 0 #c68400;
}

.status-deck {
  width: min(100%, 460px);
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
}

.status-deck span {
  min-width: 0;
  padding: 8px 8px 7px;
  border: 0;
  background: repeating-linear-gradient(180deg, rgba(53, 255, 97, 0.12) 0 2px, transparent 2px 5px), #050505;
  color: #35ff61;
  font-size: 12px;
  font-weight: 900;
  line-height: 1;
  text-align: center;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 9px rgba(53, 255, 97, 0.8);
  box-shadow: 4px 4px 0 #000, inset 0 0 0 3px #1b1b1b, inset 0 -4px 0 rgba(53, 255, 97, 0.12);
  clip-path: polygon(0 0, calc(100% - 6px) 0, 100% 6px, 100% 100%, 6px 100%, 0 calc(100% - 6px));
  white-space: nowrap;
}

.status-deck span:nth-child(2) {
  color: #12e7ff;
  text-shadow: 0 0 9px rgba(18, 231, 255, 0.8);
}

.status-deck span:nth-child(3) {
  color: #f8ec18;
  text-shadow: 0 0 9px rgba(248, 236, 24, 0.85);
}

.entry-panel {
  width: min(100%, 560px);
  padding: 20px;
  border: 5px solid #e7e7e7;
  outline: 5px solid #060606;
  background: linear-gradient(90deg, rgba(18, 231, 255, 0.08), transparent 14%, transparent 86%, rgba(255, 37, 37, 0.08)), repeating-linear-gradient(180deg, #0b0b0b 0 7px, #060606 7px 14px);
  box-shadow: 8px 8px 0 #000, inset 0 0 0 5px #2b2b2b, inset 0 0 22px rgba(18, 231, 255, 0.1);
  text-align: center;
  clip-path: polygon(0 0, calc(100% - 16px) 0, 100% 16px, 100% 100%, 16px 100%, 0 calc(100% - 16px));
}

.entry-heading {
  display: flex;
  justify-content: center;
  gap: 12px;
  color: #fff8cf;
  font-size: 18px;
  font-weight: 900;
  line-height: 1.2;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000;
}

.blinker {
  color: #ff2525;
  animation: blink 0.9s steps(1, end) infinite;
}

.player-input {
  width: 100%;
  margin: 16px 0;
  padding: 15px 16px 13px;
  border: 0;
  border-radius: 0;
  background: repeating-linear-gradient(180deg, rgba(53, 255, 97, 0.1) 0 3px, transparent 3px 7px), #000;
  color: #35ff61;
  font-family: inherit;
  font-size: 27px;
  font-weight: 900;
  text-align: center;
  text-transform: uppercase;
  caret-color: #ff2525;
  clip-path: polygon(0 0, calc(100% - 8px) 0, 100% 8px, 100% 100%, 8px 100%, 0 calc(100% - 8px));
  box-shadow: inset 0 0 0 4px #f8ec18, inset 0 0 0 8px #1c1c1c, 5px 5px 0 #000, inset 0 -8px 0 rgba(53, 255, 97, 0.12);
  outline: none;
  text-shadow: 2px 0 0 #003b12, 0 2px 0 #003b12, 2px 2px 0 #000, 0 0 10px rgba(53, 255, 97, 0.85);
}

.player-input::placeholder {
  color: rgba(53, 255, 97, 0.42);
}

.player-input:focus {
  box-shadow: inset 0 0 0 4px #12e7ff, inset 0 0 0 8px #1c1c1c, 5px 5px 0 #000, 0 0 18px rgba(18, 231, 255, 0.35);
}

.mode-row,
.action-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.action-row {
  margin-top: 12px;
}

.match-panel {
  margin-top: 12px;
  padding: 12px;
  border: 3px solid #242424;
  background: repeating-linear-gradient(90deg, rgba(18, 231, 255, 0.12) 0 4px, transparent 4px 9px), #030303;
  box-shadow: inset 0 0 0 3px #101010, 4px 4px 0 #000;
}

.match-heading,
.match-result {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
  line-height: 1;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000;
}

.match-heading strong {
  color: #12e7ff;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 10px rgba(18, 231, 255, 0.8);
}

.opponent-grid {
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.opponent-button {
  position: relative;
  min-width: 0;
  min-height: 46px;
  padding: 8px 8px 7px;
  border: 0;
  border-radius: 0;
  background: repeating-linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0 3px, transparent 3px 7px), #fff8cf;
  color: #111;
  font-family: inherit;
  font-weight: 900;
  line-height: 1;
  clip-path: polygon(0 0, calc(100% - 7px) 0, 100% 7px, 100% 100%, 7px 100%, 0 calc(100% - 7px));
  box-shadow: 4px 4px 0 #000, inset 0 0 0 4px #151515, inset -5px -5px 0 rgba(0, 0, 0, 0.18);
  text-shadow: 1px 1px 0 rgba(255, 255, 255, 0.55);
}

.opponent-button span,
.opponent-button small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.opponent-button span {
  font-size: 14px;
}

.opponent-button small {
  margin-top: 4px;
  font-size: 10px;
}

.opponent-button.is-active {
  background: repeating-linear-gradient(180deg, rgba(255, 255, 255, 0.2) 0 3px, transparent 3px 7px), #f8ec18;
  box-shadow: 4px 4px 0 #000, inset 0 0 0 4px #151515, inset -5px -5px 0 #c68400, 0 0 15px rgba(248, 236, 24, 0.44);
}

.match-copy {
  margin: 10px 0 0;
  color: #f8ec18;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.25;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000;
}

.match-result {
  margin-top: 12px;
  padding: 10px 10px 9px;
  border: 0;
  background: repeating-linear-gradient(180deg, rgba(248, 236, 24, 0.08) 0 3px, transparent 3px 7px), #0b0b0b;
  clip-path: polygon(0 0, calc(100% - 7px) 0, 100% 7px, 100% 100%, 7px 100%, 0 calc(100% - 7px));
  box-shadow: inset 0 0 0 3px #151515, inset 0 0 0 5px #2b2b2b, 4px 4px 0 #000;
}

.match-result strong {
  min-width: 0;
  overflow: hidden;
  color: #f8ec18;
  text-overflow: ellipsis;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 10px rgba(248, 236, 24, 0.78);
  white-space: nowrap;
}

.match-result.is-human strong {
  color: #35ff61;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 10px rgba(53, 255, 97, 0.78);
}

.mode-button,
.coin-button,
.start-button {
  position: relative;
  min-height: 54px;
  padding: 0 14px;
  border: 0;
  border-radius: 0;
  color: #111;
  font-family: inherit;
  font-size: 17px;
  font-weight: 900;
  line-height: 1;
  clip-path: polygon(0 0, calc(100% - 9px) 0, 100% 9px, 100% 100%, 9px 100%, 0 calc(100% - 9px));
  box-shadow: 6px 6px 0 #000, inset 0 0 0 4px #151515, inset -7px -7px 0 rgba(0, 0, 0, 0.22);
  text-shadow: 1px 0 0 rgba(255, 255, 255, 0.55), 0 1px 0 rgba(255, 255, 255, 0.55);
  transition: none;
  cursor: pointer;
}

.mode-button::before,
.coin-button::before,
.start-button::before,
.opponent-button::before {
  content: "";
  position: absolute;
  inset: 6px;
  background: repeating-linear-gradient(90deg, rgba(255, 255, 255, 0.22) 0 4px, transparent 4px 10px);
  opacity: 0.7;
  pointer-events: none;
}

.mode-button {
  background: repeating-linear-gradient(180deg, rgba(0, 0, 0, 0.08) 0 4px, transparent 4px 8px), #fff8cf;
}

.mode-button.is-active {
  background: repeating-linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0 4px, transparent 4px 8px), #35ff61;
  box-shadow: 6px 6px 0 #000, inset 0 0 0 4px #151515, inset -7px -7px 0 #11a53b, 0 0 16px rgba(53, 255, 97, 0.45);
}

.coin-button {
  background: repeating-linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0 4px, transparent 4px 8px), #12e7ff;
  box-shadow: 6px 6px 0 #000, inset 0 0 0 4px #151515, inset -7px -7px 0 #068ba6, 0 0 16px rgba(18, 231, 255, 0.42);
}

.start-button {
  background: repeating-linear-gradient(180deg, rgba(255, 255, 255, 0.18) 0 4px, transparent 4px 8px), #ff2525;
  color: #fff8cf;
  box-shadow: 6px 6px 0 #000, inset 0 0 0 4px #151515, inset -7px -7px 0 #a90013, 0 0 16px rgba(255, 37, 37, 0.45);
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000;
}

.start-button:disabled {
  cursor: wait;
  filter: grayscale(0.45) brightness(0.82);
}

.mode-button:hover,
.coin-button:hover,
.start-button:hover,
.opponent-button:hover {
  filter: brightness(1.12);
}

.mode-button:active,
.coin-button:active,
.start-button:active,
.opponent-button:active {
  transform: translate(5px, 5px);
  box-shadow: 1px 1px 0 #000, inset 0 0 0 4px #151515, inset -4px -4px 0 rgba(0, 0, 0, 0.22);
}

.ready-message {
  min-height: 24px;
  margin: 16px 0 0;
  color: #f8ec18;
  font-size: 17px;
  font-weight: 900;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 10px rgba(248, 236, 24, 0.75);
}

.arcade-footer {
  display: flex;
  justify-content: space-between;
  gap: 18px;
  width: min(100%, 720px);
  color: #fff;
  font-size: 16px;
  font-weight: 900;
  text-shadow: 2px 0 0 #000, 0 2px 0 #000, 2px 2px 0 #000, 0 0 8px rgba(255, 255, 255, 0.55);
}

@keyframes blink {
  50% {
    opacity: 0;
  }
}
@keyframes bubble-drift {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(8px, -12px);
  }
}
@keyframes noise-shift {
  0%, 100% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(3px, -2px);
  }
}
@keyframes crt-flicker {
  0%, 96%, 100% {
    filter: brightness(1);
  }
  97% {
    filter: brightness(1.14) contrast(1.05);
  }
}
@media (max-width: 720px) {
  .arcade-start {
    padding: 10px;
  }
  .crt-shell {
    min-height: calc(100vh - 20px);
    padding: 12px;
    border-width: 6px;
    box-shadow: 0 0 0 3px #5a5a5a, 8px 10px 0 #000, inset 0 0 0 4px #070707;
  }
  .crt-shell::before,
  .crt-shell::after,
  .cabinet-speakers,
  .logo-zone::before,
  .logo-zone::after {
    display: none;
  }
  .arcade-stage {
    min-height: calc(100vh - 68px);
    padding: 14px;
  }
  .scoreboard {
    gap: 6px;
  }
  .score-label,
  .score-slot strong {
    font-size: 18px;
  }
  .system-strip {
    grid-template-columns: repeat(2, 1fr);
    width: 100%;
  }
  .system-strip span {
    border-bottom: 2px solid #242424;
    font-size: 11px;
  }
  .system-strip span:nth-child(2) {
    border-right: 0;
  }
  .system-strip span:nth-child(3),
  .system-strip span:nth-child(4) {
    border-bottom: 0;
  }
  .bubble-logo {
    font-size: 42px;
    text-shadow: 2px 0 0 #0047a8, -2px 0 0 #0047a8, 0 2px 0 #0047a8, 0 -2px 0 #0047a8, 5px 5px 0 #ff2fb3, 8px 8px 0 #5b1fd7;
  }
  .bubble-logo::before {
    inset: -20px -28px -18px;
  }
  .arcade-kicker,
  .arcade-subtitle,
  .entry-heading {
    font-size: 16px;
  }
  .player-row {
    gap: 8px;
    min-height: 78px;
  }
  .pixel-mascot {
    transform: scale(0.78);
    margin: -8px -10px;
  }
  .entry-panel {
    padding: 16px;
    clip-path: polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px));
  }
  .status-deck {
    gap: 5px;
  }
  .status-deck span {
    padding: 6px 4px 5px;
    font-size: 10px;
  }
  .player-input {
    font-size: 22px;
  }
  .mode-row,
  .action-row,
  .opponent-grid {
    grid-template-columns: 1fr;
  }
  .mode-button,
  .coin-button,
  .start-button,
  .opponent-button span,
  .ready-message,
  .arcade-footer {
    font-size: 15px;
  }
  .match-heading,
  .match-result {
    font-size: 12px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .screen-noise,
  .arcade-stage,
  .float-bubble,
  .blinker {
    animation: none;
  }
}`],
})
export class PageDashboardComponent implements OnDestroy, OnInit {
    public playerName: string = '';
    public selectedMode: string = '1P';
    public coinCount: number = 0;
    public readyMessage: string = 'PUSH START BUTTON';
    public playerToken: string = '';
    public onlinePlayers: any[] = [];
    public selectedOpponentToken: string = 'random';
    public matchMode: string = 'pc';
    public matchOpponentName: string = 'PC';
    public matchStatus: string = 'STANDBY';
    public isSearching: boolean = false;

    public decorativeBubbles: any[] = [
        { left: '8%', top: '18%', size: '52px', delay: '0s' },
        { left: '17%', top: '56%', size: '34px', delay: '0.4s' },
        { left: '25%', top: '9%', size: '26px', delay: '0.8s' },
        { left: '72%', top: '12%', size: '46px', delay: '0.2s' },
        { left: '83%', top: '45%', size: '30px', delay: '0.7s' },
        { left: '90%', top: '66%', size: '58px', delay: '1s' }
    ];

    private heartbeatTimer: any = null;
    private beforeUnloadHandler = () => {
        this.leaveLobby();
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.playerToken = this.getPlayerToken();
        this.playerName = window.localStorage.getItem('bubble-player-name') || '';
        window.addEventListener('beforeunload', this.beforeUnloadHandler);

        await this.heartbeat();
        this.heartbeatTimer = window.setInterval(() => {
            this.heartbeat(false);
        }, 8000);
    }

    public ngOnDestroy() {
        if (this.heartbeatTimer) {
            window.clearInterval(this.heartbeatTimer);
            this.heartbeatTimer = null;
        }
        window.removeEventListener('beforeunload', this.beforeUnloadHandler);
        this.leaveLobby();
    }

    public selectMode(mode: string) {
        this.selectedMode = mode;
        this.readyMessage = `${mode} SELECTED`;
        this.matchStatus = mode === '2P' ? 'PLAYER 2 LINK' : 'PC READY';
        if (mode === '1P') {
            this.selectedOpponentToken = 'random';
            this.matchMode = 'pc';
            this.matchOpponentName = 'PC';
        }
    }

    public selectOpponent(token: string) {
        this.selectedOpponentToken = token;
        this.matchStatus = token === 'random' ? 'RANDOM PLAYER' : 'PLAYER 2 SET';
    }

    public insertCoin() {
        this.coinCount += 1;
        this.readyMessage = 'CREDIT READY';
    }

    public async startGame() {
        const name = this.normalizeName();
        window.localStorage.setItem('bubble-player-name', name);

        if (this.selectedMode === '1P') {
            this.matchMode = 'pc';
            this.matchOpponentName = 'PC';
            this.matchStatus = 'PC READY';
            this.readyMessage = `READY ${name} VS PC`;
            return;
        }

        this.isSearching = true;
        this.matchStatus = 'SEARCHING';
        this.readyMessage = 'FINDING PLAYER 2';
        await this.service.render();

        await this.heartbeat(false);
        const opponent = this.selectedOpponentToken === 'random' ? '' : this.selectedOpponentToken;
        const response: any = await wiz.call('match', {
            token: this.playerToken,
            name,
            opponent,
        });

        if (response.code === 200 && response.data) {
            this.matchMode = response.data.mode || 'pc';
            this.matchOpponentName = response.data.opponent?.name || 'PC';
            this.matchStatus = this.matchMode === 'human' ? 'PLAYER 2 READY' : 'PC READY';
            this.readyMessage = `READY ${name} VS ${this.matchOpponentName}`;
        } else {
            this.matchMode = 'pc';
            this.matchOpponentName = 'PC';
            this.matchStatus = 'PC READY';
            this.readyMessage = `READY ${name} VS PC`;
        }

        this.isSearching = false;
        await this.service.render();
    }

    public get onlineCount() {
        return this.onlinePlayers.length + 1;
    }

    public get matchBadge() {
        if (this.selectedMode === '1P') return 'SOLO';
        if (this.matchMode === 'human') return 'P2 LINK';
        return this.onlinePlayers.length > 0 ? 'P2 ONLINE' : 'PC BACKUP';
    }

    private async heartbeat(render: boolean = true) {
        const response: any = await wiz.call('heartbeat', {
            token: this.playerToken,
            name: this.normalizeName(false),
        });

        if (response.code !== 200 || !response.data) return;

        this.playerToken = response.data.player?.token || this.playerToken;
        this.onlinePlayers = (response.data.opponents || []).sort((a, b) => b.lastSeen - a.lastSeen);

        const selectedStillOnline = this.onlinePlayers.some((player) => player.token === this.selectedOpponentToken);
        if (this.selectedOpponentToken !== 'random' && !selectedStillOnline) {
            this.selectedOpponentToken = 'random';
        }

        if (this.selectedMode === '2P' && this.matchStatus === 'STANDBY') {
            this.matchStatus = this.onlinePlayers.length > 0 ? 'PLAYER 2 ONLINE' : 'PC READY';
        }

        if (render) await this.service.render();
    }

    private leaveLobby() {
        if (!this.playerToken) return;
        wiz.call('leave', { token: this.playerToken });
    }

    private getPlayerToken() {
        const storageKey = 'bubble-player-token';
        let token = window.sessionStorage.getItem(storageKey);
        if (!token) {
            token = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
            window.sessionStorage.setItem(storageKey, token);
        }
        return token;
    }

    private normalizeName(updateField: boolean = true) {
        const name = this.playerName.trim().toUpperCase() || 'PLAYER 1';
        if (updateField) this.playerName = name;
        return name;
    }
}

export default PageDashboardComponent;